<div>
  <p class="text-grey" *ngIf="headingText" class="mb-2">
    {{headingText}}
  </p>
  <ul class="custom-template-{{customType}}">
    <li *ngFor="let template of templates;let i = index; trackBy:trackByFn" class="cursor-pointer position-relative"
      [ngClass]="{'inner-outline-active-circle': (selectedTemplate === i && customType === templateType.BACKGROUND), 'inner-outline-active': (selectedTemplate === i && (customType === templateType.TEMPLATE || customType === templateType.M_WEB))}"
      [ngStyle]="{'background-image': template.gradient ? 'linear-gradient(' + template.gradient + ')' : 'url(' + getBackGroundImage(template) + '), url(assets/images/grandround/image_placeholder.svg)'}"
      (click)="selectTemplate(i , !template.src ?  template.gradient : template.src)">
    </li>
  </ul>
</div>
